export default __webpack_public_path__ + "static/media/EmailIcon.4a58d30d.svg";